import axios from 'axios'
import {ref} from "vue"
import {useApi} from "@/composition/useApi.js"

export function useBackups() {

    const { api, params } = useApi()
    const backups = ref([])
    const getBackups = () => {
        return axios.get(api + `/api/v1/cp/backups/`, params)
        .then((r) => {
            backups.value = r.data.data
        })
    }
    // Ссылка живёт 5 минут и не требует заголовка Authorization — браузер скачивает файл сам
    const downloadBackup = (name) => {
        return axios.post(api + `/api/v1/cp/backups/${name}/link/`, null, params)
        .then((r) => {
            window.location.href = api + r.data.data.url
        })
    }

    return {
        backups,
        getBackups,
        downloadBackup,
    }
}
